export default import.meta.ROLLDOWN_FILE_URL_f_JLTZHWaH18hR2YNrhwKg